import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0B] fl-grid-bg p-6" data-testid="not-found-page">
      <div className="text-center">
        <span className="grid place-items-center w-14 h-14 rounded-xl bg-[#E53E3E] mx-auto mb-6"><Zap className="w-7 h-7 text-white" strokeWidth={2.5} /></span>
        <h1 className="font-display text-7xl font-black uppercase tracking-tight text-[#E53E3E]">404</h1>
        <p className="mt-3 text-zinc-400">This page took a rest day. Let's get you back.</p>
        <Link to="/"><Button className="mt-7 bg-[#E53E3E] hover:bg-[#C53030] rounded-full font-semibold h-12 px-8">Back to Home</Button></Link>
      </div>
    </div>
  );
}
